
    import '/home/ec2-user/Youlify-Design/components/alert/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["alert-demo-basic","alert-demo-style","alert-demo-closable","alert-demo-description","alert-demo-icon","alert-demo-banner","alert-demo-loop-banner","alert-demo-smooth-closed","alert-demo-error-boundary","alert-demo-custom-icon","alert-demo-action","alert-demo-component-token"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/alert/index.zh-CN.md?type=demo')
};